module.exports = __webpack_public_path__ + "static/media/incentives-screenshot.998fb481.png";